<!-- Import CSS for Base UI -->
<!-- <link rel="stylesheet" href="/assets/css/flexie/flexie.css" data-about="flexie classes">
<link rel="stylesheet" href="/assets/css/vendor/ng-zorro-antd.min.css" data-about="Manually placed">
<link rel="stylesheet" href="/assets/css/ui-base.css" data-about="Base-UI CSS"> -->

<router-outlet></router-outlet>

<div class="show-version" *ngIf="env && env.version">
    <!-- <a [href]="env.releaseNotesLink" target="_blank">v {{env.version}}</a> -->
    v {{env.version}}
</div>